import positions from './positions'
import money from './money'
import type from './type'
import traffic from './traffic'
import goodNews from './goodNews'
import priorityPositions from './priorityPositions'
import services from './services'

export default {
  namespaced: true,
  modules: {
    positions,
    money,
    type,
    traffic,
    goodNews,
    priorityPositions,
    services
  }
}
